
import { useApplicationData } from './use-application-data';
import { useApplicationProgress } from './use-application-progress';
import { useApplicationSave } from './use-application-save';

export const useApplication = () => {
  // Extract userId from URL if it exists (for brokers viewing client applications)
  const params = new URLSearchParams(window.location.search);
  const userIdFromUrl = params.get('userId');
  
  const { application, setApplication, isLoading, error } = useApplicationData(userIdFromUrl);
  const { calculateProgress } = useApplicationProgress(application);
  const { lastSaved, saveProgress, debouncedSave } = useApplicationSave(application, setApplication, calculateProgress);

  return {
    application,
    setApplication,
    isLoading,
    error,
    lastSaved,
    saveProgress,
    debouncedSave,
    calculateProgress,
  };
};
